import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  IconButton,
  Divider,
} from '@mui/material';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { Link as RouterLink } from 'react-router-dom';
import { SITE } from '../../config/site';

export default function Footer() {
  const footerLinks = [
    { label: 'Privacy Policy', href: '/privacy' },
    { label: 'Terms of Service', href: '/terms' },
    { label: 'Contact', href: '/contact' },
  ];

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'grey.900',
        color: 'white',
        py: 6,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              {SITE.name}
            </Typography>
            <Typography variant="body2" color="grey.400">
              Multi-organization meeting transcription that just works.
            </Typography>
            <Box sx={{ mt: 2 }}>
              {SITE.socials.x && (
                <IconButton
                  component="a"
                  href={SITE.socials.x}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ color: 'grey.400', '&:hover': { color: 'white' } }}
                  aria-label="Twitter"
                >
                  <TwitterIcon />
                </IconButton>
              )}
              {SITE.socials.linkedin && (
                <IconButton
                  component="a"
                  href={SITE.socials.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ color: 'grey.400', '&:hover': { color: 'white' } }}
                  aria-label="LinkedIn"
                >
                  <LinkedInIcon />
                </IconButton>
              )}
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link
                component={RouterLink}
                to="/pricing"
                color="grey.400"
                underline="hover"
                sx={{ '&:hover': { color: 'white' } }}
              >
                Pricing
              </Link>
              <Link
                component={RouterLink}
                to="/login"
                color="grey.400"
                underline="hover"
                sx={{ '&:hover': { color: 'white' } }}
              >
                Login
              </Link>
              <Link
                component={RouterLink}
                to="/register"
                color="grey.400"
                underline="hover"
                sx={{ '&:hover': { color: 'white' } }}
              >
                Sign Up
              </Link>
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              Contact
            </Typography>
            <Typography variant="body2" color="grey.400">
              Email:{' '}
              <Link
                href={`mailto:${SITE.supportEmail}`}
                color="primary.light"
                underline="hover"
              >
                {SITE.supportEmail}
              </Link>
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: 'grey.800' }} />

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Typography variant="body2" color="grey.400">
            © {new Date().getFullYear()} {SITE.name}. All rights reserved.
          </Typography>
          <Box sx={{ display: 'flex', gap: 3 }}>
            {footerLinks.map((link) => (
              <Link
                key={link.label}
                component={RouterLink}
                to={link.href}
                color="grey.400"
                variant="body2"
                underline="hover"
                sx={{ '&:hover': { color: 'white' } }}
              >
                {link.label}
              </Link>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
